<div class="landing-container">
    <h1 class="title"> {{ reportPendingMessage }} </h1> 
    
    <ubt-loader></ubt-loader>
  </div>
  
